/* HH sticky-bar size selector (7 Sep 2026).
   Adds a glove-size <select> to the PDP sticky add-to-cart bar, next to the
   box-count select. It mirrors the buy box's own size tiles and, on change,
   clicks the matching tile so the existing buy-box logic (assets/hh-sub-tiers.js)
   stays the single source of truth for size + the add-to-cart payload.
   Loaded site-wide from hh-cart-rewards; self-guards to the PDP sticky bar. */
(function () {
  var tries = 0;
  (function init() {
    var bar = document.querySelector('[data-hh-sticky]');
    var inn = bar && bar.querySelector('.hh-sticky-in');
    var tiersRoot = document.querySelector('[data-hh-tiers]');
    if (!bar || !inn || !tiersRoot) {
      if (tries++ > 30) return;            /* not a PDP with the buy box — give up */
      return setTimeout(init, 200);
    }
    var wrap = inn.querySelector('.hh-sticky-size');
    if (!wrap) {
      wrap = document.createElement('span');
      wrap.className = 'hh-t-freqwrap hh-sticky-size';
      var s = document.createElement('select');
      s.setAttribute('data-hh-stickysize', '');
      s.setAttribute('aria-label', 'Glove size');
      wrap.appendChild(s);
      var qty = inn.querySelector('.hh-sticky-qty');
      if (qty && qty.nextSibling) inn.insertBefore(wrap, qty.nextSibling);
      else if (qty) qty.parentNode.appendChild(wrap);
      else inn.appendChild(wrap);
      s.addEventListener('change', function () {
        var tile = tiersRoot.querySelector('.hh-t-size[data-sz="' + s.value + '"]');
        if (tile) tile.click();            /* drives buy-box setSize + re-render */
      });
    }
    var sel = wrap.querySelector('select');
    function tiles() {
      return Array.prototype.map.call(tiersRoot.querySelectorAll('.hh-t-size[data-sz]'), function (t) {
        var numEl = t.querySelector('.hh-t-num');
        return {
          id: t.getAttribute('data-sz'),
          name: ((t.querySelector('.hh-t-sizename') || {}).textContent || '').trim(),
          n: numEl ? (parseInt(numEl.value, 10) || 0) : 0
        };
      });
    }
    function sync() {
      var data = tiles();
      if (!data.length) { wrap.style.display = 'none'; return; }
      wrap.style.display = '';
      var sig = data.map(function (d) { return d.id + ':' + d.name; }).join('|');
      if (sel.getAttribute('data-sig') !== sig) {
        sel.setAttribute('data-sig', sig);
        sel.innerHTML = data.map(function (d) { return '<option value="' + d.id + '">' + d.name + '</option>'; }).join('');
      }
      var dom = data.slice().sort(function (a, b) { return b.n - a.n; })[0];
      var pick = (dom && dom.n > 0) ? dom.id : (sel.value || data[0].id);
      if (sel.value !== pick) sel.value = pick;
    }
    sync();
    new MutationObserver(sync).observe(tiersRoot, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'value'] });
  })();
})();
